export default new class indexForm {
  constructor() {
    this.formSelector = '_index-form';
    this.formNameInputSelector = '_index-name-input';
    this.formPhoneInputSelector = '_index-phone-input';
    this.formEmailInputSelector = '_index-email-input';
    this.formPrivacyPolicyInputSelector = '_index-privacypolicy-input';
    this.submitBtnSelector = '_index-submit';
    this.inValidSelector = '_invalid';
    this.successSelector = '_index-success';
    this.successVisibleSelector = 'subscribe__success_visible';
    this.preLoaderSelector = '_index-form-preloader';
    this.delay = 2000;

    this.handler();
  }

  handler() {
    const form = document.querySelector(`.${this.formSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', () => {
      setTimeout(() => {
        this.checkForm(form);
      }, 0);
    });
  }

  checkForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    const privacypolicy = form.querySelector(`.${this.formPrivacyPolicyInputSelector}`);
    if (privacypolicy.checked === false) {
      privacypolicy.focus();
      return;
    }

    const inputName = form.querySelector(`.${this.formNameInputSelector}`);
    const name = inputName.value;

    const inputPhone = form.querySelector(`.${this.formPhoneInputSelector}`);
    const phone = inputPhone.value;

    const inputEmail = form.querySelector(`.${this.formEmailInputSelector}`);
    const email = inputEmail.value;

    const type = 'Главная под слайдером';

    $.request('Feedback::onSignup', {
      data: {
        name,
        email,
        phone,
        type,
      },
      complete: (res) => {
        this.showSuccess(res);
        setTimeout(() => {
          inputName.value = '';
          inputName.dispatchEvent(new Event('change', {
            bubbles: true,
          }));
          inputPhone.value = '';
          inputPhone.dispatchEvent(new Event('change', {
            bubbles: true,
          }));
          this.hideSuccess();
        }, this.delay);
      },
    });
  }

  showSuccess(res) {
    const { statusText } = res;
    if ((statusText === 'success') || (statusText === 'OK')) {
      $(`.${this.successSelector}`).addClass('show');
      // eslint-disable-next-line no-undef
      ym(71321556, 'reachGoal', 'send');
    }
  }

  hideSuccess() {
    $(`.${this.successSelector}`).removeClass('show');
  }
}();
